module.exports = __webpack_public_path__ + "images/appstore_blackwhite_6fe417b12ea67511a4fe03843f25ae5b.png";